import { QuantityType } from '@components/UI-Components/QuantityType/constants/QuantityType'
import { VIPChannel } from '@modules/common/models/enums/VIPChannel'
import has from 'lodash/has'

const getQuantityKPIs = (quantityType: string) => {
  const kpiField = QuantityType.Size === quantityType ? 'Sized' : 'Door'
  const kipFieldLabel = QuantityType.Size === quantityType ? 'Sized' : 'Draft'
  const kpiAttribute = QuantityType.Size === quantityType ? 'Size' : 'Door'
  return [
    {
      label: 'Cluster Name',
      key: 'clusterName',
      attributeId: 'clusterName',
      allowHide: false,
      allowReordering: false,
      allowedForChannels: [VIPChannel.Retail]
    },
    {
      field: 'doorOTB',
      label: 'Door OTB',
      key: 'doorOTB',
      attributeId: 'totalBudgetValue',
      allowHide: true,
      allowReordering: true,
      allowedForChannels: [VIPChannel.Retail]
    },
    {
      field: `total${kpiField}Value`,
      label: `Total ${kpiField} Value`,
      key: `total${kpiField}Value`,
      attributeId: `total${kpiAttribute}Value`,
      allowedForChannels: [VIPChannel.Retail]
    },
    {
      field: `total${kpiField}Value`,
      label: `Total ${kipFieldLabel} Value`,
      key: `total${kipFieldLabel}Value`,
      attributeId: `total${kpiAttribute}Value`,
      allowedForChannels: [VIPChannel.Wholesale],
      allowHide: true,
      allowReordering: true
    },
    {
      field: `total${kpiField}Quantity`,
      label: `Total ${kpiField} Quantity`,
      key: `total${kpiField}Quantity`,
      attributeId: `total${kpiAttribute}Quantity`,
      allowedForChannels: [VIPChannel.Retail],
      allowHide: true,
      allowReordering: true
    },
    {
      field: `total${kpiField}Quantity`,
      label: `Total ${kipFieldLabel} Quantity`,
      key: `total${kipFieldLabel}Quantity`,
      attributeId: `total${kpiAttribute}Quantity`,
      allowedForChannels: [VIPChannel.Wholesale]
    },
    {
      field: 'numberOfACs',
      label: 'Number of ACs',
      key: 'numberOfACs',
      attributeId: 'totalProducts',
      allowHide: true,
      allowReordering: true,
      allowedForChannels: [VIPChannel.Retail, VIPChannel.Wholesale]
    }
  ]
}

export const getVisibleGlobalKpiRows = (
  quantityType: string,
  channel: VIPChannel,
  hiddenTotalKpiRows?: any[]
) => {
  return getQuantityKPIs(quantityType)?.filter(
    field =>
      field?.allowedForChannels.includes(channel) &&
      !hiddenTotalKpiRows?.includes(field?.attributeId)
  )
}

export const getVisibleKpiRows = (
  quantityType: string,
  channel: VIPChannel,
  hiddenTotalKpiRows?: any[],
  tableSettingRows?: any
) => {
  return getQuantityKPIs(quantityType)?.filter(
    field =>
      field?.allowedForChannels.includes(channel) &&
      !hiddenTotalKpiRows?.includes(field?.attributeId) &&
      (tableSettingRows?.[field?.attributeId]?.isVisible ?? true)
  )
}

export const getQuantityKPILabels = (
  quantityType: string,
  channel: VIPChannel,
  hiddenTotalKpiRows?: any[],
  tableSettingRows?: any
) => {
  return getVisibleKpiRows(
    quantityType,
    channel,
    hiddenTotalKpiRows || [],
    tableSettingRows || {}
  )?.map(kpiField => ({ key: kpiField.key, label: kpiField.label }))
}

export const getQuantityKPIColumns = (
  quantityType: string,
  channel: VIPChannel,
  hiddenTotalKpiRows?: any[],
  tableSettingRows?: any
) => {
  return getVisibleKpiRows(
    quantityType,
    channel,
    hiddenTotalKpiRows || [],
    tableSettingRows || {}
  )?.filter(kpiField => has(kpiField, 'field'))
}
